import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PricingPlanComponent } from './pricing-plan/pricing-plan.component';
import { FaqComponent } from './faq/faq.component';
import { NavbarComponent } from './navbar/navbar.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { FooterComponent } from './footer/footer.component';
import { BillingHistoryComponent } from './billing-history/billing-history.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignUpComponent } from './sign-up/sign-up.component';
import { BillingComponent } from './dashboard/billing/billing.component';
import { OverviewComponent } from './dashboard/overview/overview.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ChartModule } from 'angular2-chartjs';
import { ListStoresComponent } from './dashboard/list-stores/list-stores.component';
import { Faq2Component } from './dashboard/faq2/faq2.component';
import { PaymentsComponent } from './dashboard/payments/payments.component';
import { PreferencesComponent } from './dashboard/preferences/preferences.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DealerLoginComponent } from './dealer-login/dealer-login.component';
import { StoreEditorComponent } from './dashboard/store-editor/store-editor.component';
import { AbandonedCartsComponent } from './dashboard/abandoned-carts/abandoned-carts.component';
import { DomainListComponent } from './dashboard/domain-list/domain-list.component';
import { DomainFormComponent } from './dashboard/domain-form/domain-form.component';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomersComponent } from './dashboard/customers/customers.component';
import { CustomersCartsComponent } from './dashboard/customers-carts/customers-carts.component';
import { ReplayComponent } from './dashboard/replay/replay.component';
import { HeatmapComponent } from './dashboard/heatmap/heatmap.component';
import { HeatmapViewComponent } from './dashboard/heatmap-view/heatmap-view.component';
import { VisitorIntelligenceComponent } from './dashboard/visitor-intelligence/visitor-intelligence.component';
import { RevenueLostReportComponent } from './dashboard/revenue-lost-report/revenue-lost-report.component';
import { LandingPageReportComponent } from './dashboard/landing-page-report/landing-page-report.component';
import { ReplaySessionsComponent } from './dashboard/replay-sessions/replay-sessions.component';
import { ReplayPlayerComponent } from './dashboard/replay-player/replay-player.component';
import { OrdersComponent } from './dashboard/orders/orders.component';
import { OrdersTabsComponent } from './dashboard/orders-tabs/orders-tabs.component';
import { CreateStoreComponent } from './create-store/create-store.component';
import { ProductManagerComponent } from './dashboard/product-manager/product-manager.component';
import { ETicketingComponent } from './dashboard/e-ticketing/e-ticketing.component';
import { ETicketingFormComponent } from './dashboard/e-ticketing-form/e-ticketing-form.component';
import { ETicketingListComponent } from './dashboard/e-ticketing-list/e-ticketing-list.component';
import { ETicketingInfoComponent } from './dashboard/e-ticketing-info/e-ticketing-info.component';
import { ProductManagerFormComponent } from './dashboard/product-manager-form/product-manager-form.component';
import { GalleryComponent } from './dashboard/gallery/gallery.component';
import { ThemeListComponent } from './dashboard/theme-list/theme-list.component';
import { ThemeSelectPageComponent } from './dashboard/theme-select-page/theme-select-page.component';
import { CreateMediaComponent } from './dashboard/create-media/create-media.component';
import { ContentEditorComponent } from './dashboard/content-editor/content-editor.component';
import { DiscountsComponent } from './dashboard/discounts/discounts.component';
import { AddDiscountComponent } from './dashboard/add-discount/add-discount.component';
import { PaginationComponent } from './dashboard/pagination/pagination.component';
import { ProductFilterPipe } from './dashboard/pipes/productFilter.pipe';
import { TranslationPipe } from './dashboard/pipes/translation.pipe';
import { TruncateText } from './dashboard/pipes/truncateText.pipe';
import { CountToModule } from 'angular-count-to';
import { UploadImageComponent } from './dashboard/upload-image/upload-image.component';
import { DashboardCreateStoreComponent } from './dashboard/create-store/create-store.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MediaSelectorComponent } from './components/media-selector/media-selector.component';
import { AiContentGeneratorComponent } from './components/ai-content-generator/ai-content-generator.component';
import { AiContentGeneratorInnerComponent } from './components/ai-content-generator-inner/ai-content-generator-inner.component';
import { MediaImagesSelectorComponent } from './components/media-image-selector/media-image-selector.component';

import { NgApexchartsModule } from 'ng-apexcharts';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { LoaderComponent } from './loader/loader.component';
import { EmailTemplateComponent } from './dashboard/email-template/email-template.component';
import { EditTemplateComponent } from './dashboard/edit-template/edit-template.component';
import { EmailEditorModule } from 'angular-email-editor';
import { EmailSettingComponent } from './dashboard/email-setting/email-setting.component';
import { LocationSelectorComponent } from './components/location-selector/location-selector.component';
import { KnowledgeBaseComponent } from './dashboard/knowledge-base/knowledge-basecomponent';
import { TimeagoModule } from 'ngx-timeago';
import { NotificationComponent } from './dashboard/notification/notification.component';
import { ProductEditComponent } from './dashboard/product-edit/product-edit.component';
import { MsgBoxComponent } from './shared/msgbox/msgbox.component';
import { NotifyComponent } from './shared/notify/notify.component';
import { DebugStateComponent } from './shared/debug-state/debug-state.component';
import { GenerateContentQueueIndicatorComponent } from './components/generate-content-queue-indicator/generate-content-queue-indicator.component';
import { OrdersCodComponent } from './dashboard/orders-cod/orders-cod.component';
import { DetailKnowledgeComponent } from './dashboard/detail-knowledge/detail-knowledge.component';
import { ExpressCheckoutComponent } from './dashboard/express-checkout/express-checkout.component';
import { ExpressCheckoutCreateComponent } from './dashboard/express-checkout-create/express-checkout-create.component';
import { PagesComponent } from './dashboard/pages/pages.component';
import { MenuManagerComponent } from './dashboard/menu-manager/menu-manager/menu-manager.component';

import { PageManageComponent } from './dashboard/page-manage/page-manage.component';
import { DesignComponent } from './dashboard/design/design.component';
import { ExpressCheckoutDashboardComponent } from './dashboard/express-checkout-dashboard/express-checkout-dashboard.component';
import { ReferralComponent } from './dashboard/referral/referral.component';
import { LoginComponent } from './login/login.component';
import { ProductFaqComponent } from './dashboard/product-faq/product-faq.component';
import { ProductFaqCreateComponent } from './dashboard/product-faq-create/product-faq-create.component';
import { ProductFaqEditComponent } from './dashboard/product-faq-edit/product-faq-edit.component';
import { CanDeactivateGuard } from './route.guard';
import { FacebookApiComponent } from './dashboard/facebook-api/facebook-api.component';
import { OrderSubscriptionComponent } from './dashboard/order-subscription/order-subscription.component';
import { OrderSubscriptionDetailComponent } from './dashboard/order-subscription-detail/order-subscription-detail.component';
import { AiLandingPageCompareComponent } from './dashboard/ai-landing-page-compare/ai-landing-page-compare.component';
import { AiLandingPageComponent } from './dashboard/ai-landing-page/ai-landing-page.component';
import { DomainSetupComponent } from './dashboard/preferences/components/domain-setup/domain-setup.component';
import { ProfilePreferenceComponent } from './dashboard/preferences/components/profile-preference/profile-preference.component';
import { FacebookPixelManualEventComponent } from './dashboard/preferences/components/facebook-pixel-manual-event/facebook-pixel-manual-event.component';

@NgModule({
  declarations: [
    AppComponent,
    PricingPlanComponent,
    FaqComponent,
    NavbarComponent,
    LandingPageComponent,
    FooterComponent,
    BillingHistoryComponent,
    DashboardComponent,
    SignUpComponent,
    BillingComponent,
    OverviewComponent,
    ListStoresComponent,
    Faq2Component,
    PaymentsComponent,
    PreferencesComponent,
    DomainSetupComponent,
    ProfilePreferenceComponent,
    FacebookPixelManualEventComponent,
    DealerLoginComponent,
    StoreEditorComponent,
    AbandonedCartsComponent,
    DomainListComponent,
    DomainFormComponent,
    CustomersComponent,
    CustomersCartsComponent,
    ReplayComponent,
    HeatmapComponent,
    HeatmapViewComponent,
    ReplaySessionsComponent,
    ReplayPlayerComponent,
    VisitorIntelligenceComponent,
    RevenueLostReportComponent,
    LandingPageReportComponent,
    OrdersComponent,
    OrdersTabsComponent,
    CreateStoreComponent,
    ProductManagerComponent,
    ETicketingComponent,
    ETicketingFormComponent,
    ETicketingListComponent,
    ETicketingInfoComponent,
    ProductManagerFormComponent,
    ProductEditComponent,
    PageManageComponent,
    GalleryComponent,
    ThemeListComponent,
    ThemeSelectPageComponent,
    CreateMediaComponent,
    ContentEditorComponent,
    DiscountsComponent,
    AddDiscountComponent,
    PaginationComponent,
    ProductFilterPipe,
    TranslationPipe,
    TruncateText,
    UploadImageComponent,
    DashboardCreateStoreComponent,
    MediaSelectorComponent,
    AiContentGeneratorComponent,
    AiContentGeneratorInnerComponent,
    LocationSelectorComponent,
    LoaderComponent,
    EmailTemplateComponent,
    EditTemplateComponent,
    EmailSettingComponent,
    KnowledgeBaseComponent,
    NotificationComponent,
    NotifyComponent,
    MsgBoxComponent,
    DebugStateComponent,
    GenerateContentQueueIndicatorComponent,
    OrdersCodComponent,
    DetailKnowledgeComponent,
    ExpressCheckoutComponent,
    ExpressCheckoutCreateComponent,
    MenuManagerComponent,
    PagesComponent,
    DesignComponent,
    MediaImagesSelectorComponent,
    ExpressCheckoutDashboardComponent,
    ReferralComponent,
    LoginComponent,
    ProductFaqComponent,
    ProductFaqCreateComponent,
    ProductFaqEditComponent,
    FacebookApiComponent,
    OrderSubscriptionComponent,
    OrderSubscriptionDetailComponent,
    AiLandingPageCompareComponent,
    AiLandingPageComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ChartModule,
    MatMenuModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    NgbModule,
    CoreModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDropzoneModule,
    CountToModule,
    NgApexchartsModule,
    LoadingBarRouterModule,
    DragDropModule,
    TimeagoModule.forRoot(),
    EmailEditorModule,
  ],
  providers: [CanDeactivateGuard],
  exports: [
    NotifyComponent,
    MsgBoxComponent,
    LoaderComponent,
    DebugStateComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
